import React from 'react';
import { Link } from 'react-router-dom';

export default function LegalLayout({ titre, sections }) {
  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', padding: '40px 20px', fontFamily: 'Arial,sans-serif' }}>
      <div style={{ maxWidth: 820, margin: '0 auto', background: '#fff', borderRadius: 14, padding: '40px', border: '1px solid #e8d5d0' }}>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 26, color: '#8b1a2a', marginBottom: 6 }}>{titre}</h1>
        <div style={{ fontSize: 13, color: '#9a8080', fontStyle: 'italic', marginBottom: 28 }}>Derniere mise a jour : juin 2026</div>
        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom: 24 }}>
            {s.t && <h2 style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#1a1010', marginBottom: 10 }}>{s.t}</h2>}
            {s.b.map((blk, j) => blk.ul
              ? <ul key={j} style={{ margin: '0 0 8px', paddingLeft: 20 }}>{blk.ul.map((li, k) => <li key={k} style={{ fontSize: 14, color: '#2a2020', lineHeight: 1.7, marginBottom: 4 }}>{li}</li>)}</ul>
              : <p key={j} style={{ fontSize: 14, color: '#2a2020', lineHeight: 1.7, marginBottom: 8 }}>{blk.p}</p>
            )}
          </div>
        ))}
        <div style={{ marginTop: 30, paddingTop: 20, borderTop: '1px solid #eee', fontSize: 13 }}>
          <Link to="/confidentialite" style={{ color: '#8b1a2a', marginRight: 16, textDecoration: 'none' }}>Confidentialite</Link>
          <Link to="/mentions-legales" style={{ color: '#8b1a2a', marginRight: 16, textDecoration: 'none' }}>Mentions legales</Link>
          <Link to="/cgu" style={{ color: '#8b1a2a', textDecoration: 'none' }}>Conditions d'utilisation</Link>
        </div>
      </div>
    </div>
  );
}
